export const CLOSING_MONTH = [
  { id: '1', name: '1月' },
  { id: '2', name: '2月' },
  { id: '3', name: '3月' },
  { id: '4', name: '4月' },
  { id: '5', name: '5月' },
  { id: '6', name: '6月' },
  { id: '7', name: '7月' },
  { id: '8', name: '8月' },
  { id: '9', name: '9月' },
  { id: '10', name: '10月' },
  { id: '11', name: '11月' },
  { id: '12', name: '12月' },
];
